export const CONTROL_SOCIAL_ORGANIZATION_OPTIONS = [
  { id: 'Ninguno', value: 'Ninguno' },
  { id: 'Veedurías ciudadanas', value: 'Veedurías ciudadanas' },
  {
    id: 'Instancias de participación ciudadana',
    value: 'Instancias de participación ciudadana'
  },
  { id: 'Organizaciones sociales', value: 'Organizaciones sociales' },
  { id: 'Organismos comunales', value: 'Organismos comunales' },
  { id: 'Instituciones educativas', value: 'Instituciones educativas' },
  {
    id: 'Instituciones de Educación Superior',
    value: 'Instituciones de Educación Superior'
  },
  {
    id: 'Juntas Administradoras Locales',
    value: 'Juntas Administradoras Locales'
  },
  {
    id: 'Otras modalidades de control social',
    value: 'Otras modalidades de control social'
  },
  { id: 'Otro', value: 'Otro' }
];

function normalize(value) {
  return String(value ?? '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function isOtherControlSocialOrganization(value) {
  return normalize(value) === 'otro';
}

export function resolveStoredControlSocialOrganization(value) {
  const storedValue = String(value ?? '').trim();
  if (!storedValue) return { organization: '', otherOrganization: '' };

  const predefined = CONTROL_SOCIAL_ORGANIZATION_OPTIONS.find(
    option => normalize(option.value) === normalize(storedValue)
  );

  if (predefined) {
    return { organization: predefined.id, otherOrganization: '' };
  }

  return { organization: 'Otro', otherOrganization: storedValue };
}

export function getControlSocialOrganizationValue(selection, otherOrganization) {
  return isOtherControlSocialOrganization(selection)
    ? String(otherOrganization ?? '').trim()
    : String(selection ?? '').trim();
}
